import axios from "axios";
import {
    UPDATE_USER_DATA,
    UPDATE_USER_DATA_ERROR,
    GET_ACCOUNT_USER,
    GET_ACCOUNT_USER_ERROR,
    GET_ALL_USERS,
    GET_ALL_USERS_ERROR,
    CREATE_NEW_USER,
    CREATE_NEW_USER_ERROR,
    DELETE_USER,
    DELETE_USER_ERROR,
} from "./types";


import { setAlert } from "./alerts";
import setAuthToken from "../../utils/setAuthToken";

const baseUrl = process.env.REACT_APP_BASE_URL;
// const baseUrl = 'http://localhost:3001';



// GET USER BY ID ( UPDATES USER STATE FROM AUTH REDUCER )
export const getUser = () => async (dispatch) => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        const response = await axios.get(`${baseUrl}/api/auth`);
        dispatch({
            type: GET_ACCOUNT_USER,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ACCOUNT_USER_ERROR,
            payload: { msg: "Failed to get user" },
        });
    }
};



// UPDATE USER BY ID (ANY USER, EXCEPT USER LOGGED IN AS ACCOUNT PROFILE)
// UPDATE USER BY ID (ANY USER, EXCEPT USER LOGGED IN AS ACCOUNT PROFILE)
// UPDATE USER BY ID (ANY USER, EXCEPT USER LOGGED IN AS ACCOUNT PROFILE)
export const updateUser = (userId, userData) => async (dispatch) => {
    try {
        const response = await axios.put(`${baseUrl}/api/auth/updateUser/${userId}`, {userData});

        dispatch({
            type: UPDATE_USER_DATA,
            payload: response.data,
        });

        dispatch(getAllUsers());

        dispatch(setAlert("Profile has been updated", "success"));
    } catch (err) {
        dispatch({
            type: UPDATE_USER_DATA_ERROR,
            payload: { msg: "Failed to get roles" },
        });
    }
};


// GET - ALL DPS USERS ARRAY
// GET - ALL DPS USERS ARRAY
// GET - ALL DPS USERS ARRAY
export const getAllUsers = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/auth/users`);
    
        dispatch({
            type: GET_ALL_USERS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_USERS_ERROR,
            payload: { msg: "Failed to get users" },
        });
    }
};



// POST - CREATE NEW USER FOR DPS CMS
// POST - CREATE NEW USER FOR DPS CMS
// POST - CREATE NEW USER FOR DPS CMS
export const createNewUser = (user) => async (dispatch) => {
    try {
        const response = await axios.post(`${baseUrl}/api/auth/register`, {
            user,
        });
    
        dispatch({
            type: CREATE_NEW_USER,
            payload: response.data,
        });
        dispatch(setAlert("User created successfully!", "success"));
        dispatch(getAllUsers());
    } catch (err) {
        dispatch(setAlert("Failed to create user", "danger"));
        // dispatch(getAllUsers);
        dispatch({
            type: CREATE_NEW_USER_ERROR,
            payload: { msg: "Login failure" },
        });
    }
  };




export const deleteUser = (id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${baseUrl}/api/auth/user/${id}`);
    
        dispatch({
            type: DELETE_USER,
            payload: response.data,
        });
        // dispatch(getAllUsers());
        dispatch(setAlert("User successfully deleted!", "success"));
    } catch {
        dispatch(setAlert("Could not delete user", "danger"));
        dispatch({
            type: DELETE_USER_ERROR,
            payload: { msg: "Failed to delete user" },
        });
    }
};




